import {PlayerBase} from "../../player/player.base";
import {Component, Injector} from '@angular/core';
import {GenericElm} from '../../player/generic.elm';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError} from "rxjs/operators";

@Component({
  selector: 'app-ext-video',
  template: '<div #component></div>',
  styleUrls: []
})
export class ExtVideoComponent extends PlayerBase {
  genericElm: GenericElm;

  constructor(protected injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        if (this.editMode) {
          this.showMsg(this.playerObject.$.label, this.PREVIEW)
          return of(null);
        } else {
          this.genericElm = new GenericElm(this.component);
          const url = this.data.LINK[0].$.src;
          return of(url);
        }
      }),
      switchMap(path => {
        if (path==null) {
          return of(null);
        }
        const aspectRatio = (this.data.LINK[0].AspectRatio[0].$.maintain == "1");
        const autoRewind = (this.data.LINK[0].Video[0].$.autoRewind == "1");
        const volume = Number(this.data.LINK[0].Video[0].$.volume);
        return this.genericElm.setMedia(path, aspectRatio, this.actualWidth, this.actualHeight, autoRewind, volume).pipe(
          switchMap( a=> this.genericElm.play(false) ),
        )
      }),
      catchError( err => this.logError(err) ),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  destroy(): void {
    if (this.genericElm != null) {
      this.genericElm.destroy();
    }
    super.destroy();
  }
}


/* ???
     if (url.substring(0, 4) === 'rtmp') {
       this.videoJSplayer = videojs('my-video');
       this.videoJSplayer.src({
         type: 'rtmp/mp4',
         src: url
       });
       this.videoJSplayer.play();
     } else {
       this.component.nativeElement.src = url;
     }

  */

